// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { rfqConfirmationDetailsStyles } from "@conklin/Overrides/Widgets/RfqConfirmation/RfqConfirmationDetails";
import { mergeWithCss } from "@conklin/XDL/Utilities";
import { GridItemProps } from "@insite/mobius/GridItem";
import { css } from "styled-components";

const gridItemValue: GridItemProps = { width: [12, 6, 6, 4, 4] };

rfqConfirmationDetailsStyles.detailsGridContainer = {
    gap: 24,
};
rfqConfirmationDetailsStyles.jobNameGridItem = {
    ...gridItemValue,
};
rfqConfirmationDetailsStyles.salesRepGridItem = {
    ...mergeWithCss(gridItemValue, {
        css: css`
            order: 3;
        `,
    }),
};
rfqConfirmationDetailsStyles.statusGridItem = {
    ...mergeWithCss(gridItemValue, {
        css: css`
            order: 2;
        `,
    }),
};
rfqConfirmationDetailsStyles.dateGridItem = {
    ...mergeWithCss(gridItemValue, {
        css: css`
            order: 1;
            flex-direction: column;
        `,
    }),
};
rfqConfirmationDetailsStyles.customerGridItem = {
    ...mergeWithCss(gridItemValue, {
        css: css`
            order: 4;
        `,
    }),
};
rfqConfirmationDetailsStyles.shipToGridItem = {
    ...gridItemValue,
};
rfqConfirmationDetailsStyles.notesGridItem = {
    ...gridItemValue,
};

rfqConfirmationDetailsStyles.jobNameHeadingAndText = {
    heading: {
        ...xOrderInformationStyles.label,
    },
    text: {
        ...xOrderInformationStyles.value,
    },
};
rfqConfirmationDetailsStyles.salesRepHeadingAndText = {
    heading: {
        ...xOrderInformationStyles.label,
    },
    text: {
        ...xOrderInformationStyles.value,
    },
};
rfqConfirmationDetailsStyles.statusHeadingAndText = {
    heading: {
        ...xOrderInformationStyles.label,
    },
    text: {
        ...xOrderInformationStyles.value,
    },
};
rfqConfirmationDetailsStyles.dateLabelText = {
    ...mergeWithCss(xOrderInformationStyles.label, {
        css: css`
            margin-bottom: 8px;
        `,
    }),
};
rfqConfirmationDetailsStyles.customerHeadingAndText = {
    heading: {
        ...xOrderInformationStyles.label,
    },
    text: {
        ...xOrderInformationStyles.value,
    },
};
rfqConfirmationDetailsStyles.shipToHeadingAndText = {
    ...xOrderInformationStyles.headingAndTextStyles,
};
rfqConfirmationDetailsStyles.notesHeadingAndText = {
    ...xOrderInformationStyles.headingAndTextStyles,
};
rfqConfirmationDetailsStyles.messageGridItem = {
    width: 12,
    css: css`
        order: 5;
    `,
};
